import { RecaptchaVerifier, signInWithPhoneNumber } from "@firebase/auth";
import {
  arrayUnion,
  doc,
  getDoc,
  setDoc,
  updateDoc,
} from "@firebase/firestore";
import React, { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { auth, db } from "../../firebase";

const SlidingMenu = (props) => {
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [proceed, setProceed] = useState(false);
  const [userData, setUserData] = useState(false);
  const [askUserDetails, setAskUserDetails] = useState(false);
  const [userName, setUserName] = useState("");
  const [userAddress, setUserAddress] = useState("");
  const [userPhone, setUserPhone] = useState("");

  const handleClick = () => {
    if (phone.length < 10) {
      return alert("Invalid Phone Number");
    }
    const phoneNumber = "+" + phone;
    const appVerifier = window.recaptchaVerifier;
    signInWithPhoneNumber(auth, phoneNumber, appVerifier)
      .then((confirmationResult) => {
        // SMS sent. Prompt user to type the code from the message, then sign the
        // user in with confirmationResult.confirm(code).
        window.confirmationResult = confirmationResult;
        console.log("OTP SENT");
        setProceed(true);
      })
      .catch((error) => {
        // Error; SMS not sent
        alert("Error Occured while sending OTP!");
        console.log("OTP NOT SENT", { error });
      });
  };

  const fetchUserData = async (uid) => {
    const docSnap = await getDoc(
      // doc(db, "users", "30INY5CrY1UEs4PfWlYKpdCU22F3")
      doc(db, "users", uid)
    );
    if (docSnap.exists()) {
      console.log("USER_DATA:", docSnap.data());
      setUserData({ uid: docSnap.id, ...docSnap.data() });
    } else {
      // doc.data() will be undefined in this case
      console.log("No user found!");
      setUserData({ uid });
    }
  };

  const handleLogin = () => {
    if (otp.length < 6) {
      return alert("Invalid OTP!");
    }
    window.confirmationResult
      .confirm(otp)
      .then(({ user }) => {
        console.log("USER", user);
        setUserPhone(user.phoneNumber);
        fetchUserData(user.uid);
      })
      .catch((error) => {
        alert("Error logging in!");
        console.log({ error });
      });
  };

  useEffect(() => {
    if (userData) {
      if (
        userData.name &&
        userData.phone &&
        userData.addresses &&
        userData.addresses.length
      ) {
        setPhone("");
        setOtp("");
        setProceed(false);
        setUserData(false);
        setAskUserDetails(false);
        setUserName("");
        setUserAddress("");
        setUserPhone("");
        props.onClick();
      } else {
        setUserName(userData.name ? userData.name : "");
        setUserAddress(
          userData.addresses && userData.addresses.length
            ? userData.addresses[0]
            : ""
        );
        setAskUserDetails(true);
      }
    }
    // User signed in successfully.
  }, [userData]);

  useEffect(() => {
    window.recaptchaVerifier = new RecaptchaVerifier(
      "sign-in-button",
      {
        size: "invisible",
        callback: (response) => {
          // reCAPTCHA solved, allow signInWithPhoneNumber.
          // onSignInSubmit();
        },
      },
      auth
    );
    return () => window.recaptchaVerifier.clear();
  }, []);

  return (
    <div className={"sliding-menu animated " + props.slideClass}>
      <span className="logintop" type="button" onClick={props.onClick}>
        <span className="glyphicon glyphicon-arrow-left">X</span>{" "}
        <span className="text-black">Please login to continue</span>
      </span>
      {/* LOGIN FORM */}

      {/* END LOGIN FORM */}

      {/* OTP VERIFICATION  */}
      {askUserDetails ? (
        <div className="loginScreen">
          <input
            type="text"
            name="name"
            placeholder="Name"
            value={userName}
            onChange={(e) => setUserName(e.target.value)}
          />
          <input
            type="text"
            name="address"
            placeholder="Address"
            value={userAddress}
            onChange={(e) => setUserAddress(e.target.value)}
          />
          <button
            className="btn btn-primary"
            onClick={async (e) => {
              e.preventDefault();
              try {
                const userDoc = doc(db, "users", userData?.uid);
                const docSnap = await getDoc(userDoc);
                if (docSnap.exists()) {
                  await updateDoc(userDoc, {
                    name: userName,
                    phone: userPhone,
                    address: userAddress,
                    uid: userData.uid,
                  });
                } else {
                  await setDoc(userDoc, {
                    name: userName,
                    phone: userPhone,
                    address: userAddress,
                    uid: userData.uid,
                    cart: [],
                    subscriptions: [],
                    city: "",
                    sub_history: [],
                    token: "",
                  });
                }
              } catch (e) {
                console.log("EXCEPTION:", e);
                await auth
                  .signOut()
                  .then(() =>
                    alert("Something went wrong, Please login again!")
                  );
              } finally {
                setPhone("");
                setOtp("");
                setProceed(false);
                setUserData(false);
                setAskUserDetails(false);
                setUserName("");
                setUserAddress("");
                setUserPhone("");
                props.onClick();
              }
            }}
          >
            Submit
          </button>
        </div>
      ) : (
        <div className="loginScreen">
          {proceed ? (
            <div className="text-center">
              <h4 className="">Enter 6 digit OTP Sent to your {phone} edit</h4>

              <input
                type="text"
                name="OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
              />

              {/* <p>Resend OTP</p> */}
              <button
                className="btn-primary text-center pt-1 pb-1 rounded"
                onClick={handleLogin}
              >
                Login
              </button>
            </div>
          ) : (
            <div className="LoginForm">
              <PhoneInput
                country={"in"}
                value={phone}
                onChange={(phone) => setPhone(phone)}
              />
              <button
                id="sign-in-button"
                className="btn-primary text-center pt-1 pb-1 rounded"
                onClick={handleClick}
              >
                Proceed
              </button>
              {/* <div className="recaptcha-container"></div> */}
            </div>
          )}
        </div>
      )}
      {/* END OTP VERIFICATION  */}
    </div>
  );
};

export default SlidingMenu;
